import api from "@helpers/api";

import {
  EmployeeFileInquiryResponseType,
  FileInquiryFlow,
  FileInquiryHistoryResponse,
  FileInquiryType,
} from "@type/HRM/fileInquiry";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}`;

export const createFileInquiry = (() => {
  return async (
    data: FileInquiryType,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .post(`${apiEndPoint}/enquiry/file`, data)
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();

export const updateFileInquiry = (() => {
  return async (
    id: string,
    data: FileInquiryType,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .put(`${apiEndPoint}/enquiry/file/${id}`, data)
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();

export const getFileInquiries = (() => {
  return async (
    queries: any,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .get(`${apiEndPoint}/enquiry/file`, {
        params: {
          ...queries,
        },
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();

export const getFileInquiry = (() => {
  return async (
    id: number,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .get(`${apiEndPoint}/enquiry/file/${id}`)
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();

export const getEmployeeFileInquiry = (() => {
  return async (
    id: string,
    afterEffect: (param: any) => void,
  ): Promise<{ data: EmployeeFileInquiryResponseType }> => {
    return api
      .get(`${apiEndPoint}/enquiry/file/employee/${id}`)
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();

export const getFileInquiryHistory = (() => {
  return async (
    id: string,
    afterEffect: (param: any) => void,
  ): Promise<{ data: FileInquiryHistoryResponse }> => {
    return api
      .get(`${apiEndPoint}/enquiry/file/${id}/history`)
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();

export const fileInquiryFlow = (() => {
  return async (
    id: string,
    data: FileInquiryFlow,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .put(`${apiEndPoint}/enquiry/file/${id}/workflow`, data)
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();

export const fileInquiryAssign = (() => {
  return async (
    data: {
      enquiryFileId: number;
      assigneeId: number;
      assignerId: number;
      fileFromDate: string;
    },
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .post(`${apiEndPoint}/enquiry/file/assign`, data)
      .then((response) => {
        afterEffect({
          data: response,
          status: "success",
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: "failed",
        });
        return {
          data: response,
        };
      });
  };
})();
